import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-cyan-50 text-cyan-800 transition group-hover:bg-cyan-800 group-hover:text-white" }
const _hoisted_2 = { class: "min-w-0 flex-1" }
const _hoisted_3 = { class: "block text-base font-bold text-slate-800" }
const _hoisted_4 = { class: "mt-1 block text-xs leading-5 text-slate-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "group flex min-h-32 w-full items-center gap-4 rounded-2xl border border-slate-200 bg-white p-5 text-right shadow-sm transition duration-200 hover:-translate-y-1 hover:border-cyan-200 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-cyan-700 focus:ring-offset-2",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createVNode(_component_v_icon, {
        size: "23",
        icon: _ctx.option.icon
      }, null, 8, ["icon"])
    ]),
    _createElementVNode("span", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.option.title), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.description), 1)
    ]),
    _createVNode(_component_v_icon, {
      size: "19",
      class: "shrink-0 text-slate-300 transition group-hover:-translate-x-1 group-hover:text-cyan-800"
    }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createTextVNode("mdi-arrow-left", -1)
      ]))]),
      _: 1
    })
  ]))
}